let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("i8Bdx")).then(() => parcelRequire('fMfeg'));